import palette from '../styles/palette';

export const NAME_CHOICES = [
  'Job',
  'Service',
  'Project', // NOTE: you can end up with two projects sections
  'Work Order',
];

export const JOB_STATUS = [
  {
    value: 1,
    label: "New",
    color: palette.success
  },
  {
    value: 2,
    label: "In Progress",
    color: palette.primary
  },
  {
    value: 3,
    label: "Pending",
    color: palette.dark_grey
  },
  {
    value: 4,
    label: "Completed",
    color: palette.success
  },
  {
    value: 5,
    label: "Canceled",
    color: palette.grey
  }
];
